module.exports = __webpack_public_path__ + "src/img/grade.49d98edd.svg";